module.exports = __webpack_public_path__ + "assets/img/last.56367b17.png";